/**
 * 源码中有该同名文件
 * 但是部分方法需要扩展
 * 避免代码渗透，此处重申
 */

import Element from 'zrender/lib/Element.js';
import { type ElementAnimateConfig } from 'zrender/lib/Element.js';

export interface ControllerHost {
  target: Element;
  zoom?: number;
  zoomLimit?: { min?: number; max?: number };
}

// eslint-disable-next-line complexity
export function doUpdateSeriesViewOnPanAndZoom(
  controllerHost: ControllerHost,
  {
    dx = 0,
    dy = 0,
    zoomDelta = 1,
    zoomX = 0,
    zoomY = 0,
    dirty = true
  }: {
    dx?: number;
    dy?: number;
    zoomDelta?: number;
    zoomX?: number;
    zoomY?: number;
    dirty?: boolean;
  },
  animation?: boolean | ElementAnimateConfig
) {
  const { target, zoomLimit } = controllerHost;

  // pan
  let x = target.x + dx;
  let y = target.y + dy;

  // zoom
  let { scaleX } = target;
  let { scaleY } = target;
  const originControllerHostZoom = controllerHost.zoom;
  if (typeof zoomDelta === 'number') {
    controllerHost.zoom = controllerHost.zoom || 1;
    let newZoom = controllerHost.zoom;
    newZoom *= zoomDelta;

    if (zoomLimit) {
      const zoomMin = zoomLimit.min || 0;
      const zoomMax = zoomLimit.max || Infinity;
      newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
    }
    const zoomScale = newZoom / controllerHost.zoom;
    controllerHost.zoom = newZoom;

    target.stopAnimation();

    // Keep the mouse center when scaling
    x -= (zoomX - target.x) * (zoomScale - 1);
    y -= (zoomY - target.y) * (zoomScale - 1);
    scaleX *= zoomScale;
    scaleY *= zoomScale;
  }

  const originX = target.x;
  const originY = target.y;
  const originScaleX = target.scaleX;
  const originScaleY = target.scaleY;

  if (!animation) {
    target.x = x;
    target.y = y;
    target.scaleX = scaleX;
    target.scaleY = scaleY;

    if (dirty) {
      target.dirty();
    }
  } else {
    target.animateTo({ x, y, scaleX, scaleY }, animation === true ? {} : animation);
  }

  return () => {
    target.x = originX;
    target.y = originY;
    target.scaleX = originScaleX;
    target.scaleY = originScaleY;
    controllerHost.zoom = originControllerHostZoom;
  };
}
